<template>
  <div class="timestamped-rte">
    <el-tooltip class="item" effect="dark" :content="$t('common.edit')" placement="left">
      <span v-show="allowEnterEditMode" class="floating-btn edit-btn" @click="handleEdit">
        <i class="el-icon-edit"></i>
      </span>
    </el-tooltip>

    <el-tooltip class="item" effect="dark" :content="$t('common.cancel')" placement="left">
      <span v-show="isEditMode" class="floating-btn cancel-btn" @click="handleCancel">
        <i class="el-icon-close"></i>
      </span>
    </el-tooltip>
    <rich-text-editor
      ref="rte"
      v-model="currentValue"
      class="rich-text-editor"
      v-bind="attrs"
      v-on="listeners"
      @blur.native="handleBlur"
    />
    <div class="spacer" style="clear: both;"></div>
  </div>
</template>

<script>
import RichTextEditor from '@/components/RichTextEditor';
const dayjs = require('dayjs');

export default {
  name: 'TimestampedRTE',
  components: {
    RichTextEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: '',
      isEditMode: false,
      dateTimeFormat: 'DD-MM-YYYY HH:mm',
      insertedTimestamp: false,
      initValue: ''
    };
  },
  computed: {
    attrs() {
      return { ...this.$attrs, disabled: this.isDisabled };
    },
    listeners() {
      return this.$listeners;
    },
    isDisabled() {
      return !this.isEditMode || this.disabled;
    },
    personnelReference() {
      return this.$store.state.authentication.name;
    },
    allowEnterEditMode() {
      return !this.isEditMode && !this.disabled;
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (!this.stopListeningForInitValue) {
        this.initValue = newValue;
      }
      this.currentValue = newValue;
    }
  },
  methods: {
    addTimestamp() {
      this.$refs.rte.quill.insertText(0, `\n--------------------------------\n`, 'bold', false);
      this.$refs.rte.quill.setSelection(0, 0);
      this.$refs.rte.quill.insertText(0, ' > \n');
      this.$refs.rte.quill.insertText(
        0,
        `[${dayjs().format(this.dateTimeFormat)}] ${this.personnelReference}`,
        'bold',
        true
      );
      this.insertedTimestamp = true;
    },
    handleEdit() {
      this.stopListeningForInitValue = true;
      if (!this.allowEnterEditMode) {
        return;
      }
      this.valueBeforeEdit = this.currentValue;
      this.isEditMode = true;
      if (!this.insertedTimestamp) {
        this.addTimestamp();
      }
      this.$refs.rte.quill.enable();
      this.$refs.rte.quill.focus();
    },
    handleCancel() {
      this.isEditMode = false;
      this.currentValue = this.valueBeforeEdit;
      if (this.initValue === this.currentValue) {
        this.insertedTimestamp = false;
      }
      this.$emit('input', this.currentValue);
    },
    handleBlur() {
      this.isEditMode = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.timestamped-rte {
  position: relative;
  &:hover {
    .floating-btn {
      opacity: 1;
    }
  }
  .floating-btn {
    height: 100%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    position: absolute;
    right: 0;
    opacity: 0;
    z-index: 2;
    -webkit-transition: opacity 150ms ease-in 0ms;
    transition: opacity 150ms ease-in 0ms;
    &:hover {
      cursor: pointer;
    }
  }
  .edit-btn {
    background: #e4061f;
  }
  .cancel-btn {
    background: #888889;
  }
}
</style>

<style lang="scss">
.timestamped-rte {
  .ql-editor {
    padding: 12px 50px 12px 15px;
  }
}
</style>
